import React from 'react';
import { VictoryBar, VictoryGroup, VictoryChart, VictoryAxis, LineSegment, VictoryLegend, VictoryContainer, VictoryTooltip } from 'victory'
import { groupBy, getMonthName } from './utils';
import * as Constants from './constants';

export const MonthlySectionDataChart = ({ rawData, yPropertyName, yAxisLabel }) => {
    if (!rawData || !rawData.length) {
        return null;
    }

    // Group the data by year
    const ungroupedData = rawData
        .map(d => ({
            month: d.month,
            x: d.month,
            y: d[yPropertyName],
            year: d.year,
            monthAndYear: `${d.month}-${d.year}`
        }));
    const dataByYear = groupBy(ungroupedData, "year");
    const data = Object.keys(dataByYear)
        .map(year => dataByYear[year]);

    // Create a bar chart series for each year
    const chartWidth = Constants.CHART_WIDTH;
    const chartHeight = Constants.CHART_HEIGHT;
    const charts = data.map(yearData =>
        <VictoryBar
            key={yearData[0].monthAndYear}
            data={yearData}
            labels={d => d.y > 0 ? `${getMonthName(d.month)} ${d.year}: ${d.y} ${yAxisLabel}` : null}
            labelComponent={<VictoryTooltip />}
            style={{
                labels: {
                    fontSize: Constants.DATA_LABEL_FONT_SIZE,
                    verticalAnchor: "middle"
                }
            }}
        />
    );

    const legendData = Array.from(
        new Set(rawData.map(d => d.year)))
        .sort()
        .map(year => { return { name: year.toString() } });

    // Compose the charts so they share an axis
    return (
        <div>
            <VictoryChart
                width={chartWidth}
                height={chartHeight}
                domainPadding={{ x: 30 }}
                padding={{ top: 5, right: 16, bottom: 40, left: 80 }}
            >
                <VictoryAxis crossAxis
                    domain={[1, 12]}
                    tickCount={12}
                    ticksValues={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                    tickFormat={t => getMonthName(t)}
                    label="Month"
                    gridComponent={
                        <LineSegment
                            type={"grid"}
                            style={{
                                stroke: "gray",
                                "strokeWidth": 0.5,
                            }}
                            transform="translate(27,0)" // show grid lines between months (groups) rather than in the middle of the group
                        />
                    }
                    style={{
                        tickLabels: {
                            fontSize: Constants.DATA_LABEL_FONT_SIZE,
                            padding: 5
                        },
                        axisLabel: {
                            fontSize: Constants.AXIS_LABEL_FONT_SIZE
                        }
                    }} />
                <VictoryAxis dependentAxis
                    label={yAxisLabel}
                    style={{
                        tickLabels: {
                            fontSize: Constants.DATA_LABEL_FONT_SIZE
                        },
                        axisLabel: {
                            fontSize: Constants.AXIS_LABEL_FONT_SIZE,
                            padding: 50
                        }
                    }}
                    gridComponent={
                        <LineSegment
                            type={"grid"}
                            style={{
                                stroke: "grey",
                                "strokeWidth": 0.5,
                            }}
                        />
                    }
                />
                <VictoryGroup
                    offset={10}
                    colorScale="qualitative"
                    style={{
                        data: { width: 10 }
                    }}>
                    {charts}
                </VictoryGroup>
            </VictoryChart>
            <VictoryLegend
                x={64}
                containerComponent={
                    <VictoryContainer
                        width={Constants.CHART_WIDTH}
                        height={60}
                    />}
                title="Year"
                symbolSpacer={11}
                colorScale="qualitative"
                gutter={18}
                orientation="horizontal"
                data={legendData}
                style={{
                    labels: { fontSize: Constants.DATA_LABEL_FONT_SIZE },
                    title: { fontSize: Constants.AXIS_LABEL_FONT_SIZE }
                }} />
        </div>
    );
}